import React, { useState } from 'react';
import '../App.css';

const SubscriptionModal = ({ 
  isOpen, 
  onClose, 
  prayerData, 
  isReturningUser = false,
  userStats = {}
}) => {
  const [notifyOnPrayer, setNotifyOnPrayer] = useState(true);
  const [weeklySummary, setWeeklySummary] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  if (!isOpen) return null;

  const handleSubscribe = async () => {
    setIsSubmitting(true);
    setError('');

    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
      
      const response = await fetch(`${API_URL}/api/subscriptions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          prayerId: prayerData.id,
          email: prayerData.email,
          nombre: prayerData.nombre,
          notifyOnPrayer,
          weeklySummary,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setSuccess(true);
        setTimeout(() => {
          onClose(true); // Pasar true para indicar que debe redirigir
        }, 2000);
      } else {
        setError(data.message || 'Error al crear suscripción');
      }
    } catch (err) {
      console.error('Error:', err);
      setError('Error al conectar con el servidor');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSkip = () => {
    onClose();
  };

  return (
    <div className="subscription-modal-overlay" onClick={handleSkip}>
      <div className="subscription-modal" onClick={(e) => e.stopPropagation()}>
        {success ? (
          <div className="subscription-success">
            <div className="success-icon">✅</div>
            <h2>¡Suscripción confirmada!</h2>
            <p>Recibirás un email de bienvenida en breve.</p>
          </div>
        ) : (
          <>
            <button className="modal-close" onClick={handleSkip}>×</button>
            
            <div className="modal-header">
              <div className="modal-icon">🙏</div>
              <h2>
                {isReturningUser ? '¡Bienvenido de nuevo!' : '¡Tu pedido ha sido recibido!'}
              </h2>
            </div>

            <div className="modal-content">
              {isReturningUser && (
                <div className="returning-user-message">
                  <p className="welcome-back">
                    <strong>Hola {prayerData.nombre},</strong> 
                  </p>
                  <p>
                    Ya has enviado <strong>{userStats.previousPrayers}</strong> {userStats.previousPrayers === 1 ? 'pedido' : 'pedidos'} de oración.
                    {userStats.totalPrayersReceived > 0 && (
                      <> La comunidad ha orado <strong>{userStats.totalPrayersReceived}</strong> {userStats.totalPrayersReceived === 1 ? 'vez' : 'veces'} por tus intenciones. ❤️</>
                    )}
                  </p>
                  <p className="encourage-text">
                    Vemos que la app te es útil. ¿Te gustaría recibir notificaciones?
                  </p>
                </div>
              )}

              {!isReturningUser && (
                <p className="intro-text">
                  Mantente conectado con tu pedido de oración
                </p>
              )}

              <div className="email-display">
                <span className="email-label">📧 Enviaremos notificaciones a:</span>
                <span className="email-value">{prayerData.email}</span>
              </div>

              <div className="subscription-options">
                <label className="option-item checked">
                  <input
                    type="checkbox"
                    checked={notifyOnPrayer}
                    onChange={(e) => setNotifyOnPrayer(e.target.checked)}
                  />
                  <div className="option-content">
                    <strong>Avísame cuando alguien ore por mi intención</strong>
                    <span className="option-description">
                      Recibirás un email cada vez que alguien se una en oración
                    </span>
                  </div>
                </label>

                <label className="option-item">
                  <input
                    type="checkbox"
                    checked={weeklySummary}
                    onChange={(e) => setWeeklySummary(e.target.checked)}
                  />
                  <div className="option-content">
                    <strong>Resumen semanal</strong>
                    <span className="option-description">
                      Nuevos pedidos de la comunidad + reflexiones espirituales
                    </span>
                  </div>
                </label>
              </div>

              {error && (
                <div className="error-message">
                  ⚠️ {error}
                </div>
              )}

              <div className="modal-actions">
                <button
                  className="btn-subscribe"
                  onClick={handleSubscribe}
                  disabled={isSubmitting || (!notifyOnPrayer && !weeklySummary)}
                >
                  {isSubmitting ? 'Suscribiendo...' : 'Suscribirme'}
                </button>
                <button
                  className="btn-skip"
                  onClick={handleSkip}
                  disabled={isSubmitting}
                >
                  Ahora no
                </button>
              </div>

              <p className="privacy-note">
                📝 Podrás cambiar tus preferencias en cualquier momento desde los emails
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SubscriptionModal;